export default __webpack_public_path__ + "static/media/logo.05e3030b.svg";